import { render, staticRenderFns } from "./giacenza.vue?vue&type=template&id=08993f17"
import script from "./giacenza.vue?vue&type=script&lang=js"
export * from "./giacenza.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports